import script from "./ComboBoxPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ComboBoxPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ComboBoxPrimary.vue?vue&type=style&index=0&id=4af8c56a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af8c56a"]])

export default __exports__